import { Cloner } from '../hooks/Cloner';

const Summation = ({ text: values, valuesSource, component: child }) => {
  const sum = values?.reduce((acc, v) => acc + v[valuesSource], 0);
  return child ? Cloner(child, sum.toString()) : sum;
};

export default Summation;
